module.exports = __webpack_public_path__ + "media/images/icons/infinity-cc3fb5de7c393dcfef042ce90aac19e0.svg";